import { SellerListing } from "@/interfaces/listing/SellerListing";

export interface Specs {
  icon: { src: string; size: number };
  text: string;
  getter: (listing: SellerListing) => unknown;
  value?: string;
}

export type DisplayedSpecs = Pick<Specs, "icon" | "text" | "value">;

export const SPECS_LIST: Record<string, Specs> = {
  Miles: {
    icon: { src: "/assets/listings/miles.png", size: 32 },
    text: "Miles",
    getter: (listing: SellerListing) => {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "decimal",
        maximumFractionDigits: 2,
      });
      return formatter.format(listing.Mileage);
    },
  },
  Transmission: {
    icon: { src: "/assets/listings/gearbox.png", size: 32 },
    text: "Transmission",
    getter: (listing: SellerListing) => {
      return listing.Transmission?.split(" Transmission")[0];
    },
  },
  InteriorColor: {
    icon: { src: "/assets/listings/interior.png", size: 34 },
    text: "Interior",
    getter: (listing: SellerListing) => {
      return listing.InteriorColor;
    },
  },
  Engine: {
    icon: { src: "/assets/listings/engine.png", size: 34 },
    text: "Engine",
    getter: (listing: SellerListing) => {
      return listing.Engine;
    },
  },
  Fuel: {
    icon: { src: "/assets/listings/fuel.png", size: 34 },
    text: "Fuel",
    getter: (listing: SellerListing) => {
      return listing.Fuel;
    },
  },
  AutoDrive: {
    icon: { src: "/assets/listings/drive.png", size: 38 },
    text: "Drive",
    getter: (listing: SellerListing) => {
      return listing.DriveType;
    },
  },
  MotorcycleDrive: {
    icon: { src: "/assets/listings/drive-type.svg", size: 27 },
    text: "Drive type",
    getter: (listing: SellerListing) => {
      return listing.additionalDetails?.motorcycle?.driveType;
    },
  },
  MotorcycleCategory: {
    icon: { src: "/assets/listings/motorcycle-category.svg", size: 48 },
    text: "Category",
    getter: (listing: SellerListing) => {
      return listing.additionalDetails?.motorcycle?.category;
    },
  },
  // ATV
  ATVWeight: {
    icon: { src: "/assets/listings/weight.svg", size: 26 },
    text: "Weight",
    getter: (listing: SellerListing) => {
      return listing.additionalDetails?.atv?.weight;
    },
  },
  ATVDriveType: {
    icon: { src: "/assets/listings/drive-type.svg", size: 27 },
    text: "Drive type",
    getter: (listing: SellerListing) => {
      return listing.additionalDetails?.atv?.driveType;
    },
  },
};
